import React from 'react';
import pic1 from './pic1.jpg';

const ServicesSection = () => (
  <section className="section" id="services">
    <img className="section-bg-img" src={pic1} alt="" />
    <div className="section-shade" aria-hidden="true" />
    <div className="section-container services-container">
      <header className="section-heading light">
        <div>
          <span className="section-kicker">Everything your freight needs</span>
          <h2>Built to keep<br /><em>business moving.</em></h2>
        </div>
        <p>
          Flexible and reliable transportation solutions with the equipment,
          visibility and support your cargo deserves.
        </p>
      </header>

      <div className="services-grid">
        <article>
          <span className="service-icon">↗</span>
          <span className="card-number">01</span>
          <h3>Freight transportation</h3>
          <p>Dependable local and regional shipping options, delivered on time.</p>
        </article>
        <article>
          <span className="service-icon">⌁</span>
          <span className="card-number">02</span>
          <h3>Dedicated routes</h3>
          <p>Custom routes designed for regular and high-volume shipments.</p>
        </article>
        <article>
          <span className="service-icon">◎</span>
          <span className="card-number">03</span>
          <h3>Real-time tracking</h3>
          <p>Clear shipment updates from pickup through final delivery.</p>
        </article>
        <article>
          <span className="service-icon">◇</span>
          <span className="card-number">04</span>
          <h3>Specialized equipment</h3>
          <p>Refrigerated trailers and qualified tanker endorsement drivers.</p>
        </article>
      </div>
    </div>
  </section>
);

export default ServicesSection; 